import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CardImage from 'components/cards/CardImage';
import TranslatedText from 'components/i18n/TranslatedText';
// eslint-disable-next-line no-restricted-imports
import Button from 'components/admin2/ui/Button';
import { useRealtimeDocument } from 'hooks';
import { TEXT_H6_BOLD, TEXT_P1, TEXT_BUTTON_NORMAL, SINGLE_LINE_ELLIPSIS, MULTI_LINE_ELLIPSIS } from 'style/mixins';
import { HIGHLIGHT_SECONDARY, ACCENT_PRIMARY, TEXT_100 } from 'style/constants';

const Body = styled.div`
  padding: 5px;
  padding-top: 20px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Question = styled.div.attrs({
  maxLines: 3,
})`
  padding: 0 15px 10px 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
`;

const QuestionText = styled.div.attrs({
  maxLines: 3,
})`
  ${TEXT_P1}
  font-size: 16px;
  ${MULTI_LINE_ELLIPSIS}
`;

const StyledButton = styled(Button).attrs((props) => ({
  background: ACCENT_PRIMARY(props),
  fullwidth: true,
  textColor: TEXT_100(props),
}))`
  ${TEXT_BUTTON_NORMAL}
`;

const Title = styled.div`
  ${TEXT_H6_BOLD}
  ${SINGLE_LINE_ELLIPSIS}
  color: ${HIGHLIGHT_SECONDARY};
  position: absolute;
  top: 10px;
  left: 17px;
  max-width: calc(100% - 60px);
`;

const propTypes = {
  cardPanelActive: PropTypes.bool.isRequired,
  collapsed: PropTypes.bool.isRequired,
  doc: PropTypes.shape({
    data: PropTypes.shape({
      kind: PropTypes.string,
      question: PropTypes.object, //eslint-disable-line
    }),
    renderer: PropTypes.shape({}),
  }).isRequired,
  loggedIn: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  openPanel: PropTypes.func.isRequired,
  renderer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    pollId: PropTypes.string.isRequired,
    title: PropTypes.string,
  }).isRequired,
  trackCard: PropTypes.func.isRequired,
};

export default function PollCard({
  cardPanelActive,
  collapsed,
  doc,
  loggedIn,
  onDismiss,
  openPanel,
  renderer: { pollId, title },
  trackCard,
}) {
  const [poll] = useRealtimeDocument('objects', pollId);

  const questionReference = useMemo(
    () => ({
      kind: 'poll',
      poll: {
        _id: pollId,
        collection: 'polls',
      },
    }),
    [pollId],
  );
  const questionText = poll?.data?.question;

  const handleClick = () => {
    // TODO: Could useCallback this if we wanted
    if (!cardPanelActive) {
      openPanel({
        doc: {
          data: {
            anonymous: !loggedIn,
            cardDoc: doc, // TODO: RENDERER INSTEAD
            kind: 'multiple_choice',
            questions: [questionReference],
          },
        },
      });

      trackCard('engage', doc.renderer);
    }
  };

  return (
    <CardImage isCollapsed={collapsed} onClose={onDismiss}>
      <Title>{title || <TranslatedText stringKey="AUDIENCE_POLL" />}</Title>
      <Body>
        {questionText && (
          <>
            <Question>
              <QuestionText>{questionText}</QuestionText>
            </Question>
            <StyledButton onClick={handleClick}>
              <TranslatedText stringKey="ACTION_VOTE_NOW" />
            </StyledButton>
          </>
        )}
      </Body>
    </CardImage>
  );
}

PollCard.propTypes = propTypes;
